import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { getCategoryList } from "store/features";

import { updateUserDefinedColumnOrder } from "api/data";

import { useFieldGroupDataQueryKeys } from "components/user-defined-columns/queries";

interface UpdateColumnOrderPayload {
  groupName: string;
  items: Array<{ id: string; withinSubgroupOrder: number }>;
  projectId?: string;
  isProjectDefined?: boolean;
}

const useCustomColumnOrderMutation = (isOrg, entityKind, fieldGroup, projectId?) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation<unknown, Error, UpdateColumnOrderPayload>(
    async (data) => {
      const {
        groupName,
        items,
        projectId: dataProjectId,
        isProjectDefined: dataIsProjectDefined
      } = data;
      const result = await updateUserDefinedColumnOrder(
        items,
        isOrg,
        entityKind,
        groupName,
        dataProjectId || projectId,
        dataIsProjectDefined
      );
      return result;
    },
    {
      onSuccess: () => {
        dispatch(getCategoryList(entityKind));
        queryClient.invalidateQueries([
          useFieldGroupDataQueryKeys.fieldGroupData,
          fieldGroup,
          entityKind,
          isOrg
        ]);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (err: any) => {
        const errorMessage =
          typeof err.response?.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.statusText ||
              "Could not update order";

        toast.error(errorMessage);
      }
    }
  );

  return mutation;
};

export default useCustomColumnOrderMutation;
